import { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2, School } from 'lucide-react';
import { AuthContext } from '@/lib/auth';

interface RequireAuthProps {
  children: React.ReactNode;
}

export function RequireAuth({ children }: RequireAuthProps) {
  const { session, isLoading } = useContext(AuthContext);
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-50 to-blue-100">
        <div className="w-full max-w-md space-y-8">
          <div className="flex flex-col items-center">
            <School className="h-12 w-12 text-primary animate-bounce" />
            <h1 className="mt-4 text-3xl font-bold">Teacher Reporter</h1>
            <p className="mt-2 text-muted-foreground animate-pulse">
              Preparing your dashboard...
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/auth/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}